import { useState } from 'react';
import Panel from '../Panel';
import ContactHistoryTab from './tabs/ContactHistoryTab';
import ActivityLogTab from './tabs/ActivityLogTab';

interface Props {
    notes: any[];
    campaign: any;
    campaignRequest?: any;
    setNotes: any;
    loadingNotes?: boolean;
}

type TabType = 'notes' | 'activity';

const SidebarTabs: React.FC<Props> = ({
    notes,
    campaign,
    campaignRequest,
    setNotes,
    loadingNotes = false,
}) => {
    const [activeTab, setActiveTab] = useState<TabType>('notes');
    const [activityLogCount, setActivityLogCount] = useState<number>(0);

    return (
        <Panel addClasses='bg-white border-stroke !p-3'>
            <div className='overflow-hidden p-1'>
                {/* Tab Navigation - matches ActivitiesTabs styling */}
                <div className='mb-5 flex rounded-full bg-[#FFF5E6] p-1'>
                    <button
                        onClick={() => setActiveTab('notes')}
                        className={`flex-1 rounded-full px-4 py-2 text-[14px]/[18px] font-bold transition-colors ${
                            activeTab === 'notes'
                                ? 'bg-[#FEBF3E] text-black'
                                : 'bg-transparent text-body hover:bg-[#FFE4B5]'
                        }`}
                    >
                        Campaign Notes{' '}
                        <span
                            className={`ml-1 inline-flex h-5 w-5 items-center justify-center rounded-full text-[11px] ${
                                activeTab === 'notes'
                                    ? 'bg-black text-white'
                                    : 'bg-body text-white'
                            }`}
                        >
                            {notes.length}
                        </span>
                    </button>
                    <button
                        onClick={() => setActiveTab('activity')}
                        className={`flex-1 rounded-full px-4 py-2 text-[14px]/[18px] font-bold transition-colors ${
                            activeTab === 'activity'
                                ? 'bg-[#FEBF3E] text-black'
                                : 'bg-transparent text-body hover:bg-[#FFE4B5]'
                        }`}
                    >
                        Activity Log{' '}
                        <span
                            className={`ml-1 inline-flex h-5 w-5 items-center justify-center rounded-full text-[11px] ${
                                activeTab === 'activity'
                                    ? 'bg-black text-white'
                                    : 'bg-body text-white'
                            }`}
                        >
                            {activityLogCount}
                        </span>
                    </button>
                </div>

                {/* Tab Content - both rendered, inactive hidden to preserve state */}
                <div className={activeTab !== 'notes' ? 'hidden' : ''}>
                    <ContactHistoryTab
                        notes={notes}
                        campaign={campaign}
                        campaignRequest={campaignRequest}
                        setNotes={setNotes}
                        loadingNotes={loadingNotes}
                    />
                </div>
                <div className={activeTab !== 'activity' ? 'hidden' : ''}>
                    <ActivityLogTab
                        campaign={campaign}
                        onCountChange={setActivityLogCount}
                    />
                </div>
            </div>
        </Panel>
    );
};

export default SidebarTabs;
